import { ThemeEvents, VariantUpdateEvent } from '@theme/events';
import { Component } from '@theme/component';

/** @typedef {Record<string, boolean>} SaleMap */

class ProductNotice extends Component {
  /** @type {SaleMap | null} */
  #saleMap = null;

  connectedCallback() {
    super.connectedCallback();
    const target = this.closest('.shopify-section, dialog, product-card');
    target?.addEventListener(ThemeEvents.variantUpdate, this.updateNotices);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    const target = this.closest('.shopify-section, dialog, product-card');
    target?.removeEventListener(ThemeEvents.variantUpdate, this.updateNotices);
  }

  /** @returns {SaleMap} */
  get saleMap() {
    if (this.#saleMap) return this.#saleMap;
    const json = this.querySelector('script[type="application/json"]')?.textContent;
    if (!json) return {};
    try {
      this.#saleMap = /** @type {SaleMap} */ (JSON.parse(json));
      return this.#saleMap;
    } catch {
      return {};
    }
  }

  /** @param {Event} event */
  updateNotices = (event) => {
    if (!(event instanceof VariantUpdateEvent)) return;

    const variant = /** @type {{id?: string | number} | null} */ (event.detail?.resource);
    if (!variant?.id) return;

    const onSale = this.saleMap[String(variant.id)] === true;

    for (const notice of this.querySelectorAll('[data-sale-only]')) {
      if (notice instanceof HTMLElement) notice.hidden = !onSale;
    }
  };
}

if (!customElements.get('product-notice')) {
  customElements.define('product-notice', ProductNotice);
}
